export const COMMISSION_STATUS = {
  TO_BE_PAID: 'Á pagar',
  INVOICE_CREATED: 'Faturado',
  PAID: 'Pago',
}
